export default __webpack_public_path__ + "static/media/time.5346f562.svg";